import React, { memo, useState } from 'react'

import { v4 as uniqid } from 'uuid'

import { MdRadioButtonChecked, MdRadioButtonUnchecked } from 'react-icons/md'

import arePropsEqual from '@function/arePropsEqual'

import bemit from '@function/bemit'

export default memo(function Radio ({ name, label, checked, onChange, ...props })
{
	const [id, setId] = useState(uniqid());

	const Icon = checked ? MdRadioButtonChecked : MdRadioButtonUnchecked;

	const modifiers = (checked ? ['active'] : [])
	.concat(props['read-only'] ? ['disabled'] : []);

	return (
		<div className={ bemit('c-radio', modifiers.concat(props.bemit || [])) }>

			{
				props['top-label'] ?
				(
					<label htmlFor={ props.id || id }
						className="c-radio__top-label">
						{ props['top-label'] }
					</label>
				)
				: undefined
			}

			<div className="c-radio__content">
				<input type="Radio" checked={ checked === true }
					name={ name } value={ props.value } id={ props.id || id }
					className="c-radio__input"
					onChange={ onChange }
					disabled={ props['read-only'] }
				/>
				<label htmlFor={ props.id || id } className="c-radio__label">
					<Icon className="c-radio__icon" />
					{ label }
				</label>
			</div>

		</div>
	);
},
arePropsEqual);